// NOTE: Dependencies: jQuery & Masonry

(function ($) {
	$.fn.lmImageGrid = function(options) {
		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			selector: '.image-card'
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function($context) {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);
		}

		// On load function
		methods.initContext = function($context) {
			methods.setCurrentSettings($context);

			$(window).load(function () {
				var selectorString = $context.attr('class');
				selectorString = '.' + selectorString.replace(" ", ".") + ' ' + settings.selector;

				$context.masonry({
					itemSelector: selectorString,
					percentPosition: true,
					gutter: 20
				});
			});
		}

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data("initialized");
		}

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			var $this = $(this);

			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($this);
		});
	};
}(jQuery));
